import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import RateAdminExtraProductCategoryScreen from "../../../container/RateAdminScreen/RateAdminExtraProductCategoryScreen";
import CreateRateAdminExtraProductCategory from "../../../container/RateAdminScreen/RateAdminExtraProductCategoryScreen/CreateRateAdminExtraProductCategory";

const RateAdminExtraProductCategoryRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.RATEADMIN_EXTRAPRODUCTCATEGORY.HOME}
          element={
            <RateAdminExtraProductCategoryScreen screenPermissions={access} />
          }
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.RATEADMIN_EXTRAPRODUCTCATEGORY.CREATE}
          element={<CreateRateAdminExtraProductCategory />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.RATEADMIN_EXTRAPRODUCTCATEGORY.EDIT}
          element={<CreateRateAdminExtraProductCategory isEdit={true} />}
        />
      )}
    </>
  );
};

export default RateAdminExtraProductCategoryRoutes;
